import { useId } from 'react';
import classes from './panel.module.css';

/**
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode} [props.children]
 * @param {boolean} props.isOpen
 * @param {(value: boolean) => void} props.isOpenChange
 * @param {boolean} [props.hidden]
 * @returns {React.JSX.Element}
 */
export function Panel({ label, children, isOpen, isOpenChange, hidden }) {
  const drawerId = useId();

  const togglePanel = () => {
    isOpenChange(!isOpen);
  };

  return (
    <>
      <div className={`${classes.panel} ${isOpen ? classes.panelOpen : ''} ${hidden ? classes.panelHidden : ''}`}>
        <div className={classes.toggle}>
          <button
            onClick={togglePanel}
            className={classes.toggleBtn}
            aria-controls={drawerId}
            aria-expanded={isOpen}
            aria-label={isOpen ? `Hide ${label ?? ''}` : undefined}
          >
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M9.91663 14.0002L15.1666 19.2502L16.8 17.5877L13.2125 14.0002L16.8 10.4127L15.1666
                  8.75016L9.91663 14.0002ZM2.3333 14.0002C2.3333 12.3863 2.63955 10.8696 3.25205 9.45016C3.86455
                  8.03072 4.6958 6.79599 5.7458 5.74599C6.7958 4.696 8.03052 3.86475 9.44996 3.25225C10.8694
                  2.63975 12.3861 2.3335 14 2.3335C15.6139 2.3335 17.1305 2.63975 18.55 3.25225C19.9694 3.86475
                  21.2041 4.696 22.2541 5.74599C23.3041 6.79599 24.1354 8.03072 24.7479 9.45016C25.3604 10.8696
                  25.6666 12.3863 25.6666 14.0002C25.6666 15.614 25.3604 17.1307 24.7479 18.5502C24.1354 19.9696
                  23.3041 21.2043 22.2541 22.2543C21.2041 23.3043 19.9694 24.1356 18.55 24.7481C17.1305 25.3606
                  15.6139 25.6668 14 25.6668C12.3861 25.6668 10.8694 25.3606 9.44996 24.7481C8.03052 24.1356
                  6.7958 23.3043 5.7458 22.2543C4.6958 21.2043 3.86455 19.9696 3.25205 18.5502C2.63955 17.1307
                  2.3333 15.614 2.3333 14.0002ZM4.66663 14.0002C4.66663 16.6057 5.5708 18.8127 7.37913
                  20.621C9.18747 22.4293 11.3944 23.3335 14 23.3335C16.6055 23.3335 18.8125 22.4293 20.6208
                  20.621C22.4291 18.8127 23.3333 16.6057 23.3333 14.0002C23.3333 11.3946 22.4291 9.18766 20.6208
                  7.37933C18.8125 5.57099 16.6055 4.66683 14 4.66683C11.3944 4.66683 9.18747 5.57099 7.37913
                  7.37933C5.5708 9.18766 4.66663 11.3946 4.66663 14.0002Z"
              />
            </svg>
            {!isOpen && (
              <>
                <br />
                Show {label ?? ''}
              </>
            )}
          </button>
        </div>
        <div
          id={drawerId}
          role="complementary"
          style={{ overflow: 'hidden', zIndex: 1 }}
          area-hidden={isOpen ? null : 'true'}
        >
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </>
  );
}
